import React, { useState } from 'react';
import { IconClose, IconMenu } from '@noths/polaris-client-ribbons-design-system';

import * as S from '../PhotoPicker.styles';

interface Props {
  deleteLabel: string;
  onDelete: (url: string) => void;
  onReorder: (from: number, to: number) => void;
  previewFor: (url: string) => string | undefined;
  urls: string[];
}

export function PhotoPickerGrid({ deleteLabel, onDelete, onReorder, previewFor, urls }: Props) {
  const [dragging, setDragging] = useState<number | null>(null);
  const isReorderable = urls.length > 1;

  return (
    <S.Grid role="list">
      {urls.map((url, i) => {
        const src = previewFor(url) ?? url;
        return (
          <S.Tile
            draggable={isReorderable}
            key={url}
            onDragOver={(e) => e.preventDefault()}
            onDragStart={() => setDragging(i)}
            onDrop={() => {
              if (dragging !== null && dragging !== i) {
                onReorder(dragging, i);
              }
              setDragging(null);
            }}
            role="listitem"
          >
            <img alt="" src={src} />
            <S.DeleteButton aria-label={deleteLabel} onClick={() => onDelete(url)} type="button">
              <IconClose color="currentColor" height={16} width={16} />
            </S.DeleteButton>
            <S.TilePositionBadge aria-hidden="true">{i + 1}</S.TilePositionBadge>
            {isReorderable && (
              <S.TileDragHandle aria-hidden="true">
                <IconMenu height={24} width={24} />
              </S.TileDragHandle>
            )}
          </S.Tile>
        );
      })}
    </S.Grid>
  );
}
